<template>
	<div class="search">

		<div class="map-wrap">
			<map-search-field class="map-search-field"/>
			<div class="map" id="map" ref="map"></div>
		</div>

		<results />

	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import Results from '@/components/search/results'
import MapSearchField from '@/components/search/map-search-field'
import L from "leaflet"

export default {
	name: 'search',
	data: function() {
		return {
			map_osm: false,
			markers_layer: false,
			user_map_action: false
		}
	},
	computed: {
		...mapGetters([ "projects", "nb_results", "active_project" ])
	},
	watch: {
		nb_results: function(newValue, oldValue) {
			console.log(newValue);
			this.$nextTick(function() {
				this.update_map()
			})
		}
	},
	methods: {
		...mapActions(['set_bounding_box']),
		update_map: function() {
			console.trace()
			let self = this
			this.$store.dispatch("set_last_action");
			if (this.markers_layer) {
				this.map_osm.removeLayer(this.markers_layer)
				this.markers_layer = L.layerGroup().addTo(this.map_osm)
			}
			if (self.projects.length) {
				let lats = []
				let lngs = []
				for (var i in self.projects) {
					var project = self.projects[i]
					if (project.position && project.position.location) {
						if (project.position.location.lat && project.position.location.lon) {
							var icon = L.divIcon({
								className: "map-icon " + project.segment.code,
								html: '<div class="pin"><div class="round"></div></div>'
							})
							var marker = new L.marker(
								[project.position.location.lat, project.position.location.lon],
								{ icon: icon, title: project.nom, project: project }
							)
							marker.on("click", function(e) {
								self.$store.dispatch("toggle_active_project", {
									project: this.options.project
								})
							})
							marker.addTo(self.markers_layer)
							marker._icon.setAttribute('id', 'pin-project-' + project.id)
							lats.push(project.position.location.lat)
							lngs.push(project.position.location.lon)
						}
					}
				}
				console.log(lats);
				console.log(lngs);
				if (!this.user_map_action) {
					let minlat = Math.min.apply(null, lats)
					let maxlat = Math.max.apply(null, lats)
					let minlng = Math.min.apply(null, lngs)
					let maxlng = Math.max.apply(null, lngs)
					let bbox = [[minlat,minlng],[maxlat,maxlng]]
					this.map_osm.fitBounds(bbox)
				}

				this.user_map_action = false
			}
		},
		init_map: function() {
			this.$store.dispatch("set_last_action");
			if (this.$refs.map && !this.map_osm) {
				var coords = [46.52863469527167, 2.43896484375]

				var GrayLight = L.tileLayer(
					"http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
					{ attribution: '&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }
				)
				this.map_osm = L.map("map", {
					center: coords,
					zoomSnap: 0.25,
					zoom: 9,
					minZoom: 3,
					zoomControl: true,
					layers: [GrayLight]
				})

				this.markers_layer = L.layerGroup().addTo(this.map_osm)
				this.map_osm.on('zoomend', () => this.notif_map_changed());
				this.map_osm.on('dragend', () => this.notif_map_changed());
			}
		},
		notif_map_changed({resetLocation = false} = {}) {
			this.$gtm.trackEvent({
				category: 'Search',
				action: 'Geolocation',
				label: 'Map moved'
      		});

			this.user_map_action = true
			const bb = {
				north: this.map_osm.getBounds().getNorth(),
				south: this.map_osm.getBounds().getSouth(),
				east: this.map_osm.getBounds().getEast(),
				west: this.map_osm.getBounds().getWest(),
			}
			// save to Vuex bounding box
			this.set_bounding_box({bounding_box: bb, resetLocation});
		}
	},
	mounted() {
		console.log("mount")
		this.$nextTick(function() {
			this.init_map()
			this.update_map()
		})
	},
	components: { Results, MapSearchField }
}
</script>

<style lang="stylus">
@import '../assets/css/app'

.search
	position absolute
	left 0
	right 0
	top (104px + 80px + 120px)
	height calc(100% - 120px)
	transition 0.25s easeOutQuart

	.map-search-field
		position absolute
		z-index 1000
		top 12px
		left 50px
	
	.map-wrap
		float left
		height 100%
		width 50%
		background-color #eee
		border-right 2px solid #eee
		.map
			height 100%
			.map-icon
				margin-top -24px !important
				margin-left -12px
				width 24px !important
				height 24px !important
				&:before
					content ''
					position absolute
					left 0
					top 0
					height 100%
					width 100%
					background blue
					border-radius 100%
					box-shadow 0 0 0 1px lighten(blue, 10%)
				&:after
					content ''
					position absolute
					left 25%
					top 25%
					height 50%
					width 50%
					background #fff
					border-radius 100%
				&.LLI
					&:before
						box-shadow 0 0 0 1px lighten(orange, 20%)
					&:before, .pin
						background-color orange
				&.AUT
					&:before
						box-shadow 0 0 0 1px lighten(darken(#4fa16e, 10%), 20%)
					&:before, .pin
						background-color darken(#4fa16e, 10%)
				&.EXP
					&:before
						box-shadow 0 0 0 1px lighten(#607D8B, 20%)
					&:before, .pin
						background-color #607D8B
				&.PSLA
					&:before
						box-shadow 0 0 0 1px lighten(darken(#bdcf75, 10%), 20%)
					&:before, .pin
						background-color darken(#bdcf75, 10%)
				&.LIB
					&:before
						box-shadow 0 0 0 1px lighten(blue, 20%)
					&:before, .pin
						background-color blue
				&.TER
					&:before
						box-shadow 0 0 0 1px lighten(#2f4b7c, 20%)
					&:before, .pin
						background-color #2f4b7c
				&.RSS
					&:before
						box-shadow 0 0 0 1px lighten(darken(#f19452, 25%), 20%)
					&:before, .pin
						background-color darken(#f19452, 25%)
				&.LLS
					&:before
						box-shadow 0 0 0 1px lighten(purple, 20%)
					&:before, .pin
						background-color purple
				&.RSE
					&:before
						box-shadow 0 0 0 1px lighten(darken(#d43d51, 10%), 20%)
					&:before, .pin
						background-color darken(#d43d51, 10%)
				&.REL
					&:before
						box-shadow 0 0 0 1px lighten(darken(#d43d51, 10%), 20%)
					&:before, .pin
						background-color darken(#d43d51, 30%)

				&.active
					z-index 100000 !important
					&:before
						box-shadow 0 0 0 1px lighten(red, 0%)
					&:before, .pin
						background-color red
				.pin
					content ''
					position absolute
					left 0
					top 25%
					height 100%
					width 100%
					background blue
					transform rotate(45deg) scale(0.6)
		
	.results
		float left
		height 100%
		width 50%
		background-color #fff



</style>
